document.addEventListener("click", event => {
	if (event.target instanceof HTMLButtonElement) {
		if (event.target.hasAttribute("focus")) {
			const focus = event.target.getAttribute("focus");
			const element = document.querySelector(focus);

			if (element) {
				const { top, height } = element.getBoundingClientRect();

				window.scrollTo({
					top: top + window.scrollY - (window.innerHeight - height) / 2,
					behavior: "smooth"
				});
			}
		}
	}
});